export default __webpack_public_path__ + "static/media/305.31187e3a.gif";